module.exports = __webpack_public_path__ + "images/779eaa65e17dbf38a9324b7bf2e1dec2.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/wine.jpg
// module id = 739
// module chunks = 0